import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableColumnEditorComponent } from './component/table-column-editor.component';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TableColumnEditorComponent
  ],
  exports: [
    TableColumnEditorComponent],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ]
})
export class TableColumnEditorModule { }
